var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeclined = function SvgDeclined(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solid/16*16/informative/declined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 8.10758C14.6666 11.7895 11.6819 14.7743 7.99998 14.7743C4.31808 14.7743 1.33331 11.7895 1.33331 8.10758C1.33331 4.42569 4.31808 1.44092 7.99998 1.44092C11.6819 1.44092 14.6666 4.42569 14.6666 8.10758ZM10.2392 10.3467C10.0439 10.542 9.72731 10.542 9.53205 10.3467L7.99999 8.81465L6.46791 10.3467C6.27265 10.542 5.95607 10.542 5.76081 10.3467C5.56554 10.1515 5.56554 9.83488 5.76081 9.63962L7.29288 8.10754L5.76082 6.57548C5.56555 6.38022 5.56555 6.06364 5.76082 5.86837C5.95608 5.67311 6.27266 5.67311 6.46792 5.86837L7.99999 7.40044L9.53204 5.86838C9.72731 5.67312 10.0439 5.67312 10.2391 5.86838C10.4344 6.06364 10.4344 6.38023 10.2391 6.57549L8.70709 8.10754L10.2392 9.63961C10.4344 9.83487 10.4344 10.1515 10.2392 10.3467Z",
    fill: "#CF1322"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeclined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "declined.94776134eeaf1a10eea09f00486afa8b.svg";